/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_TitleInputs */

const en_booking_title = /** @type {(inputs: Booking_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book your lesson.`)
};

const es_booking_title = /** @type {(inputs: Booking_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reserva tu lección.`)
};

const de_booking_title = /** @type {(inputs: Booking_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buchen Sie Ihre Golfstunde.`)
};

const zh_booking_title = /** @type {(inputs: Booking_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预订课程。`)
};

const ar_booking_title = /** @type {(inputs: Booking_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`احجز درسك.`)
};

const fr_booking_title = /** @type {(inputs: Booking_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réservez votre cours.`)
};

const vi_booking_title = /** @type {(inputs: Booking_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đặt buổi học của bạn.`)
};

const sw_booking_title = /** @type {(inputs: Booking_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weka nafasi ya somo lako.`)
};

const th_booking_title = /** @type {(inputs: Booking_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จองบทเรียนของคุณ`)
};

const bs_booking_title = /** @type {(inputs: Booking_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezervišite svoju lekciju.`)
};

const ja_booking_title = /** @type {(inputs: Booking_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レッスンの予約`)
};

const ko_booking_title = /** @type {(inputs: Booking_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`레슨을 예약하세요.`)
};

const pt_booking_title = /** @type {(inputs: Booking_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agende sua aula.`)
};

const it_booking_title = /** @type {(inputs: Booking_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prenota la tua lezione.`)
};

const sv_booking_title = /** @type {(inputs: Booking_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boka din lektion.`)
};

const nl_booking_title = /** @type {(inputs: Booking_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boek je les.`)
};

const da_booking_title = /** @type {(inputs: Booking_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book din lektion.`)
};

const nb_booking_title = /** @type {(inputs: Booking_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestill leksjonen din.`)
};

const fi_booking_title = /** @type {(inputs: Booking_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varaa oppituntisi.`)
};

const pl_booking_title = /** @type {(inputs: Booking_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarezerwuj swoją lekcję.`)
};

const ru_booking_title = /** @type {(inputs: Booking_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запишитесь на урок.`)
};

const tr_booking_title = /** @type {(inputs: Booking_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dersinizi ayırtın.`)
};

const hi_booking_title = /** @type {(inputs: Booking_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपना पाठ बुक करें।`)
};

const id_booking_title = /** @type {(inputs: Booking_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesan pelajaran Anda.`)
};

const ms_booking_title = /** @type {(inputs: Booking_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempah pelajaran anda.`)
};

const cs_booking_title = /** @type {(inputs: Booking_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objednejte si lekci.`)
};

const el_booking_title = /** @type {(inputs: Booking_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Κλείστε το μάθημά σας.`)
};

const he_booking_title = /** @type {(inputs: Booking_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הזמינו את השיעור שלכם.`)
};

const af_booking_title = /** @type {(inputs: Booking_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bespreek jou les.`)
};

const hu_booking_title = /** @type {(inputs: Booking_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foglald le az órádat.`)
};

/**
* | output |
* | --- |
* | "Book your lesson." |
*
* @param {Booking_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_title = /** @type {((inputs?: Booking_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_title(inputs)
	if (locale === "de") return de_booking_title(inputs)
	if (locale === "zh") return zh_booking_title(inputs)
	if (locale === "ar") return ar_booking_title(inputs)
	if (locale === "fr") return fr_booking_title(inputs)
	if (locale === "vi") return vi_booking_title(inputs)
	if (locale === "sw") return sw_booking_title(inputs)
	if (locale === "th") return th_booking_title(inputs)
	if (locale === "bs") return bs_booking_title(inputs)
	if (locale === "ja") return ja_booking_title(inputs)
	if (locale === "ko") return ko_booking_title(inputs)
	if (locale === "pt") return pt_booking_title(inputs)
	if (locale === "it") return it_booking_title(inputs)
	if (locale === "sv") return sv_booking_title(inputs)
	if (locale === "nl") return nl_booking_title(inputs)
	if (locale === "da") return da_booking_title(inputs)
	if (locale === "nb") return nb_booking_title(inputs)
	if (locale === "fi") return fi_booking_title(inputs)
	if (locale === "pl") return pl_booking_title(inputs)
	if (locale === "ru") return ru_booking_title(inputs)
	if (locale === "tr") return tr_booking_title(inputs)
	if (locale === "hi") return hi_booking_title(inputs)
	if (locale === "id") return id_booking_title(inputs)
	if (locale === "ms") return ms_booking_title(inputs)
	if (locale === "cs") return cs_booking_title(inputs)
	if (locale === "el") return el_booking_title(inputs)
	if (locale === "he") return he_booking_title(inputs)
	if (locale === "af") return af_booking_title(inputs)
	if (locale === "hu") return hu_booking_title(inputs)
	return en_booking_title(inputs)
});